export enum Methods {
    GET = 'GET',
    POST = 'POST',
    Delete = 'Delete'
}

export interface ApiResult {
    /**
     * 状态码
     */
    code: number,
    /**
     * 返回信息
     */
    sub_msg?: string,
    /**
     * 返回信息
     */
    msg: string,
    /**
     * 返回的结果数据
     */
    result: any,
    /**
     * 返回的结果数据
     */
    data: any,
    /**
     * 是否成功
     */
    issucess: boolean
}